import Layout from './components/Layout';
import Navbar from './components/Navbar';

function App() {
  return (
    <div className="container-fluid">
      <Navbar />
      <Layout />
    </div>
  );
}

export default App;
